import "./KeyIndicatorsComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {AccountPerformanceViewStore} from "../../service/AccountPerformanceViewStore";
import {Observable, ReplaySubject} from "rxjs";
import {AccountMarginSummary} from "../../models/AccountPerformanceSummary";
import {OptionSummary} from "./models/OptionSummary";
import {EquitySummary} from "./models/EquitySummary";
import {IsoDate} from "../../../pseudo-types/DateTypes";
import {OptionSummaryCalculator} from "./util/OptionSummaryCalculator";
import {EquitySummaryCalculator} from "./util/EquitySummaryCalculator";
import {Pair} from "../../../types/GenericTypes";
import {
    HistoricalTrades,
    isHistoricalEquityTrade,
    isHistoricalExerciseTrade,
    isHistoricalOptionTrade
} from "../../models/HistoricalTradeData";

export const AccountPerformanceKeyIndicators = "tfAccountPerformanceKeyIndicators";

export function accountPerformanceKeyIndicators(): IComponentOptions {
    return {
        templateUrl: "app/performance/components/key-indicators/KeyIndicatorsComponent.html",
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: KeyIndicatorsComponentController
    };
}

export class KeyIndicatorsComponentController implements IOnInit, IOnDestroy {

    public readonly viewStore: AccountPerformanceViewStore;

    public optionSummary: OptionSummary;
    public equitySummary: EquitySummary;
    public totalPnl: number;

    public readonly asAt$ = new ReplaySubject<IsoDate>(1);

    public optionSectionOpen = false;
    public equitySectionOpen = false;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(public readonly $scope: IScope) {

    }

    public $onInit() {

        const nlvSource$ = this.viewStore
                               .accountPerformance
                               .map((summary) => summary.marginHistory);

        Observable.combineLatest(this.viewStore.tradeHistory, this.viewStore.dateRange, nlvSource$)
                  .debounceTime(100)
                  .takeUntil(this.destroyed$)
                  .subscribe(([trades, range, marginSummary]) => this.calculateTotals(trades, range, marginSummary));

        this.viewStore
            .dateRange
            .takeUntil(this.destroyed$)
            .map((r) => r[0])
            .subscribe((date) => this.asAt$.next(date));
    }

    private calculateTotals(trades: HistoricalTrades,
                            range: Pair<IsoDate>,
                            marginHistory: ReadonlyArray<AccountMarginSummary>) {
        const equity = trades.filter(isHistoricalEquityTrade);
        const options = trades.filter(isHistoricalOptionTrade);
        const cash = trades.filter(isHistoricalExerciseTrade);

        this.$scope.$applyAsync(() => {
            this.optionSummary = OptionSummaryCalculator.calculate(options, cash, range, marginHistory);
            this.equitySummary = EquitySummaryCalculator.calculate(equity, range, marginHistory);
            this.totalPnl = this.optionSummary.pnl + this.equitySummary.pnl;
        });
    }

    public $onDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
